import React from 'react'
type props = {
  currentList: any[]
}
const ModalDetail = ({ currentList }: props) => {
  return (
    <div>
      <table className=" w-full text-center mt-5">
        <thead className="text-white bg-[#4682B4]">
          <tr className="border">
            <td className="border p-1">Mã máy</td>
            <td className="border p-1">Tên máy</td>
          </tr>
        </thead>
        <tbody>
          {currentList.map((item, index) => {
            return (
              <tr className="border" key={index}>
                <td className="border p-1">{item.equipmentCode}</td>
                <td className="border p-1">{item.equipmentName}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ModalDetail